import { createFileRoute } from "@tanstack/react-router";
import { useAuth } from "@/hooks/use-auth";

export const Route = createFileRoute("/admin/account")({
  component: AdminAccount,
});

function AdminAccount() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="rounded-lg border border-border p-6 bg-card space-y-2">
      <h2 className="text-lg font-medium">Admin account</h2>
      <p className="text-sm text-muted-foreground">Email: {user.email}</p>
      <p className="text-sm text-muted-foreground">User ID: {user.id}</p>
    </div>
  );
}
